var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquare3Stack3D = function SvgSquare3Stack3D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.356 1.59a.75.75 0 0 0-.712 0l-9.75 5.25a.75.75 0 0 0 0 1.32l2.953 1.59-2.953 1.59a.75.75 0 0 0 0 1.32l2.953 1.59-2.953 1.59a.75.75 0 0 0 0 1.32l9.75 5.25c.222.12.49.12.712 0l9.75-5.25a.75.75 0 0 0 0-1.32l-2.953-1.59 2.953-1.59a.75.75 0 0 0 0-1.32l-2.953-1.59 2.953-1.59a.75.75 0 0 0 0-1.32zM3.832 12l2.597-1.398 5.215 2.808c.222.12.49.12.712 0l5.215-2.808L20.168 12l-2.952 1.59L12 16.398zm8.524 5.91 5.215-2.808 2.597 1.398L12 20.898 3.832 16.5l2.597-1.398 5.215 2.808c.222.12.49.12.712 0M3.832 7.5 12 3.102 20.168 7.5l-2.952 1.59L12 11.898z",
    clipRule: "evenodd"
  })));
};
export default SvgSquare3Stack3D;